import config from '@/config'
import { createAuthenticatedFetch } from '@/helpers/api/httpClient'
import {
	toPaymentKindQuery,
	type AdminTransactionListResponse,
	type PaginationResponse,
	type SearchAdminTransactionsRequest,
	type TransactionAnalyticsSummaryResponse,
	type TransactionDetailResponse,
} from './transactionTypes'

const apiFetch = createAuthenticatedFetch()
const baseUrl = () => `${config.API_URL}/api/subscription`

async function parseJson<T>(response: Response): Promise<T> {
	if (!response.ok) {
		const err = await response.json().catch(() => ({}))
		return Promise.reject(err)
	}
	return response.json() as Promise<T>
}

export const transactionAdminApi = {
	search: async (request: SearchAdminTransactionsRequest) => {
		const res = await apiFetch(`${baseUrl()}/transactions/search`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(request),
		})
		return parseJson<PaginationResponse<AdminTransactionListResponse>>(res)
	},

	getAnalyticsSummary: async (request: SearchAdminTransactionsRequest) => {
		const res = await apiFetch(`${baseUrl()}/transactions/analytics/summary`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(request),
		})
		return parseJson<TransactionAnalyticsSummaryResponse>(res)
	},

	getById: async (id: number, kind: string | number | undefined) => {
		const res = await apiFetch(`${baseUrl()}/transactions/${id}?kind=${toPaymentKindQuery(kind)}`)
		return parseJson<TransactionDetailResponse>(res)
	},
}
